import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ClientProvider } from '@internal-providers/client.provider';
import { translate } from '@shared-libs/helpers';

@Component({
	selector: 'client-digicheques-count-component',
	templateUrl: 'client-digicheques-count.component.html',
	styleUrls: ['./client-digicheques-count.component.scss'],
})
export class ClientDigichequesCountComponent implements OnChanges {
	@Input() public clientId: string;
	public digichequeCount: number | string = translate('UNKNOWN');

	constructor(private readonly provider: ClientProvider) {}

	public async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes.clientId?.currentValue) {
			this.digichequeCount = await this.provider.getDigichequeCount(changes.clientId?.currentValue);
		}
	}
}
